<template>
  <div>
    <div class="padding">
      <div class="banner-sm">
        <div class="inner">
          <div class="banner-text">
            Wallpapers
            <small>Designed in love of visual art & photography.</small>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row wallpapers">
          <div
            class="wallpaper-wrapper"
            v-for="(item, index) in wallpapers"
            :key="index"
          >
            <span class="time">
              {{ time }} <small>{{ date }}</small>
            </span>
            <!--                        <span class="time"> {{ time }} {{period}} <small>{{ date }}</small> </span>-->
            <span
              class="photo"
              :style="{
                'background-image':
                  'url(\'/img/mobile-wallpaper/low/' + item + '\')',
              }"
            ></span>
            <a
              :href="'/img/mobile-wallpaper/' + item"
              class="download-text"
              download
            >
              Download
            </a>
            <span class="phone"></span>
            <span class="unlock"></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  created() {
    const time = new Date();
    const hours = time.getHours();
    this.time = (hours % 12 || 12) + ":" + time.getMinutes();
    this.date =
      this.days[time.getDay()] +
      ", " +
      this.months[time.getMonth()] +
      " " +
      time.getDate();
    this.period = hours > 12 ? "PM" : "AM";
  },
  data() {
    return {
      days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      date: "",
      time: "",
      period: "",
      wallpapers: [
        "waiting for angel purple.jpg",
        "under water.jpg",
        "syria war.jpg",
        "space.jpg",
        "scene.jpg",
        "scene 2.jpg",
        "Rising Falling or get stuck.jpg",
        "on the edge.jpg",
        "Im out of here.jpg",
        "huanted.jpg",
        "Holding the Moon.jpg",
        "fox.jpg",
        "fly.jpg",
        "elephant under city light.jpg",
        "cyclon.jpg",
        "andre-benz-501829-unsplash.jpg",
        "06032019 (9).jpg",
        "06032019 (7).jpg",
        "06032019 (6).jpg",
        "06032019 (4).jpg",
        "06032019 (3).jpg",
        "06032019 (1).jpg",
      ],
    };
  },
};
</script>